<template>
  <div>
    <hr class="top" />
    <!-- <el-button plain style="margin-left: 3%"
      ><a
        :href="[
          '//183.175.59.23:8003/download?type=csv&params=' +
            this.$route.query['rank'],
        ]"
        >CSV</a
      ></el-button
    >
    <el-button plain
      ><a
        :href="[
          '//183.175.59.23:8003/download?type=csv&params=' +
            this.$route.query['rank'],
        ]"
        >Excel</a
      ></el-button
    >
    <el-button plain
      ><a
        :href="[
          '//183.175.59.23:8003/download?type=txt&params=' +
            this.$route.query['rank'],
        ]"
        >TXT</a
      ></el-button
    > -->
    <div style="text-align: right; margin-right: 10%">
      Search :<el-input v-model="search_val"></el-input>
    </div>
    <el-table :data="datalist" border stripe>
      <el-table-column
        type="index"
        :index="(page - 1) * page_size + 1"
        :resizable="false"
        label="#"
        width="60px"
      ></el-table-column>
      <el-table-column label="Organism" prop="tax_id">
        <template slot-scope="scope">
          <a
            :href="[
              'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' +
                scope.row.tax_id,
            ]"
            style="text-decoration: none"
            >{{ scope.row.organism }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="Protein(s)" prop="tax_id">
        <template slot-scope="scope">
          <a
            :href="['@/../#/access?id=' + scope.row.tax_id]"
            style="text-decoration: none"
            ><el-button type="info" plain>Browse</el-button></a
          >
        </template>
      </el-table-column>
      <el-table-column label="Domain" prop="superkingdom"></el-table-column>
      <el-table-column label="Kingdom" prop="kingdom"></el-table-column>
      <el-table-column label="Phylum" prop="phylum"></el-table-column>
      <el-table-column label="Class" prop="class_field"></el-table-column>
      <el-table-column label="Order" prop="order_field"></el-table-column>
      <el-table-column label="Family" prop="family"></el-table-column>
      <el-table-column label="Genus" prop="genus"></el-table-column>
      <el-table-column label="Species" prop="species"></el-table-column>
    </el-table>
    <hr />
    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <hr />
  </div>
</template>

<script>
export default {
  //data
  data() {
    return {
      total: null,
      datalist: [],
      page_size: 10,
      page: 1,
      search_val: "",
    };
  },
  //钩子函数
  created() {
    this.getData();
  },

  //methods
  methods: {
    async getData() {
      const res = await this.$http.get('taxonomy'+ "/", {
        params: {
          params: this.$route.query["rank"],
          page: this.page,
          page_size: this.page_size,
        },
      });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    }, //
    async SearchData() {
      const res = await this.$http.get("taxsearch" + "/", {
        params: {
          rank: this.$route.query["rank"],
          page: this.page,
          page_size: this.page_size,
          word: this.search_val,
        },
      });
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
    },

    //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.page_size = newPage_size;
      this.getData();
    },
    //监听当前页变化
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.getData();
    },
  },
  //
  watch: {
    $route(to, from) {
      this.getData();
    },
    search: function () {
      this.SearchData();
    },
    //
    search_val: function () {
      // 实现input连续输入，只发一次请求
      this.loading_show = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.SearchData();
      }, 300);

    },
    //
  },
};
</script>

<style  lang="less" scoped>
.el-form-item {
  width: 300px;
  margin: 0;
  /deep/ .el-form-item__label {
    width: 100px;
  }
  /deep/.el-form-item__content {
    width: 200px;
  }
}
.el-pagination {
  display: flex;
  justify-content: center;
}
/deep/.el-table--border td{
border:0.8px solid rgb(235, 236, 235);
}
.el-table {
  /deep/ th {
    background-color: #adc3ce;
    color: rgb(8, 0, 0);
    font-size: 1.3em;
    text-align: center;
  }
  /deep/ td {
    text-align: center;
  }
}
.top {
  margin-top: 40px;
}
button {
  a {
    font-size: 13px;
    text-decoration: none;
    color: black;
  }
  a:hover {
    color: rgb(11, 68, 153);
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input {
  display: inline-block;
  width: 150px;
  height: 45px;
  padding-left: 20px;
}
</style>